 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import OEBPSHALFTITLE from '@/components/OEBPS/halftitle'
 import OEBPSSERIES from '@/components/OEBPS/series'
 import OEBPSTITLEPAGE from '@/components/OEBPS/titlepage'
 import OEBPSCOPY from '@/components/OEBPS/copy'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSINTRO from '@/components/OEBPS/intro'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCONCLUSION from '@/components/OEBPS/conclusion'
 import OEBPSABB from '@/components/OEBPS/abb'
 import OEBPSNOTE1 from '@/components/OEBPS/note1'
 import OEBPSNOTE2 from '@/components/OEBPS/note2'
 import OEBPSBIB from '@/components/OEBPS/bib'
 import OEBPSINDEX from '@/components/OEBPS/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cover",
 			"name" : "OEBPS/cover",
 			"component" : OEBPSCOVER
 		},
 		{
 			"path" : "/OEBPS/halftitle",
 			"name" : "OEBPS/halftitle",
 			"component" : OEBPSHALFTITLE
 		},
 		{
 			"path" : "/OEBPS/series",
 			"name" : "OEBPS/series",
 			"component" : OEBPSSERIES
 		},
 		{
 			"path" : "/OEBPS/titlepage",
 			"name" : "OEBPS/titlepage",
 			"component" : OEBPSTITLEPAGE
 		},
 		{
 			"path" : "/OEBPS/copy",
 			"name" : "OEBPS/copy",
 			"component" : OEBPSCOPY
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/ack",
 			"name" : "OEBPS/ack",
 			"component" : OEBPSACK
 		},
 		{
 			"path" : "/OEBPS/intro",
 			"name" : "OEBPS/intro",
 			"component" : OEBPSINTRO
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js